import {MagicBlueBulbService} from './magic-blue-bulb.service';
import {NgModule} from '@angular/core';
export class MagicBlueBulbModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  providers: [MagicBlueBulbService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MagicBlueBulbModule_tsickle_Closure_declarations() {
/** @type {?} */
MagicBlueBulbModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MagicBlueBulbModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
